module.exports = __webpack_public_path__ + "static/media/icon-logoff.d0876133.png";